import React, { useCallback, useEffect, useState } from "react";
import Stack from "react-bootstrap/Stack";
import {
  Container,
  Tabs,
  Tab,
  Col,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Header from "./components/Header";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/Store";
import Case_Subject from "../Case_Subject/components/Add_Update_Subject";
import Stakeholders from "./components/Stakeholders";
import CaseBillingAddConfiguration from "./components/CaseBillingAddConfiguration";
import CaseBillingList from "./components/CaseBillingList";
import { fetchPickListByGroupName } from "../../../services/CaseInformationApi";
import {
  CASE_STAGE_STATUS,
  PICKLIST_GROUP_NAME,
  STAKEHOLDER_LIST_CODE,
  WEB_ROLE,
} from "../../../common/Constant";
import InjuryDetailsTable from "../../Case_Management/Case_Subject/components/InjuryTable";
import InjuryForm from "../../Case_Management/Case_Subject/components/Injury_Deails_Form";
import {
  setBillingAvailable,
  setCaseId,
  setCaseInfoId,
  setCaseStage,
  setClaimNumber,
  setClientId,
  setCaseTypeName,
  setInjuryAvailable,
  setIsSearchEditable,
  setIsUploadFile,
  setQMEScheduleAvailable,
  setRecordAvailable,
  setPatientDetails,
  setIsViewSchedule,
} from "../../../redux/slice/CaseHeaderSlice";
import { fetchSubjectInfo } from "../../../services/Case_SubjectAPI";
import AppointmentList from "../CaseQME_Schedule/components/Appointment_list";
import ScheduleAppointment from "../CaseQME_Schedule/components/ScheduleAppointment";
import { setCaseSubjectId } from "../../../redux/slice/CaseSubjectSlice";
import UploadRecords from "../Case_Records/components/UploadRecords";
import RecordListNew from "../Case_Records/components/Record_List";
import Preferences from "../Case_Records/components/Preferences";
import SummaryReport from "../Summary_Report/components/Summary_Report";
import NotesDrawer from "../Case_Notes/NotesDrawer";
import AddCaseNotes from "../Case_Notes/AddCaseNotes";
import { FetchInjuryDetails } from "../../../services/InjuryAPI";
import StageStatusLogs from "./components/StageStatusLogs";
import { setCurrentStage } from "../../../redux/slice/caseStagesSlice";
import CaseActivityList from "../Case_Activities/components/CaseActivityList";
import { fetcheaderinfo } from "../../../services/UserRegistrationApi";
import ViewInvoice from "../../Invoice/ManageInvoice/components/ViewInvoice";
import AllRushNotesDetails from "../../dashboard/Summary/CommonDashboard/AllRushNotesDetails";
import AppointmentActionDrawer from "../../Appointments/components/AppointmentActionDrawer";
import { getAllRushNotes } from "../../../services/ActionStatusApi";

interface AddNewProps {
  userData: any;
  action: string;
  onCancel: (action: string) => void;
  tabState?: string;
}

const TABS = [
  "Patient",
  "QME Schedule",
  "Records",
  "Activities",
  "Summary",

  "Invoice",
];

const CreateNewCase: React.FC<AddNewProps> = ({
  userData,
  action,
  onCancel,
  tabState,
}) => {
  const dispatch = useDispatch();
  const { view_Case } = useSelector((state: RootState) => state.featureAccess);
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const {
    caseid,
    claimnumber,
    status,
    caseStage,
    caseInfoId,
    isUploadFile,
    isInjuryAvailable,
    isRecordAvailable,
    isQMEScheduleAvailable,
    isBillingAvailable,
    isViewSchedule,
    patientDetails,
    CaseTypeName,
  } = useSelector((state: RootState) => state.caseHeader);
  const { caseSubjectId } = useSelector(
    (state: RootState) => state.caseSubject,
  );
  const { currentStage } = useSelector((state: RootState) => state.caseStages);
  const [activeTab, setActiveTab] = useState<string>("");
  const [responseCaseid, setResponseCaseid] = useState<any[]>([]);
  const [injuryActiveTab, setInjuryActiveTab] = useState("");
  const [newStage, setNewStage] = useState<string | null>(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [qmeActiveTab, setQmeActiveTab] = useState("");
  const [billingActiveTab, setbillingActiveTab] = useState("");
  const [selectedRecordRowData, setSelectedRecordRowData] = useState(null);
  const [recordActiveTab, setRecordActiveTab] = useState("");
  const [isRecordRowActionTriggered, setIsRecordRowActionTriggered] =
    useState(false);
  const [isStageLogOpen, setIsStageLogOpen] = useState<boolean>(false);
  const [subTab, setSubTab] = useState<string>(tabState || "Injury");
  const [caseSubjectIdNew, setCaseSubjectIdNew] = useState<number | null>(null);
  const [gender, setGender] = useState<string | null>(null);
  const [isRowActionTriggered, setIsRowActionTriggered] = useState(false);
  const [shouldRefreshActivity, setShouldRefreshActivity] = useState(false);
  const [showUploadWarning, setShowUploadWarning] = useState(false);
  const [caseSubjectInjuryID, setCaseSubjectInjuryID] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showRushNotes, setShowRushNotes] = useState(false);
  const [userRole, setUserRole] = useState("");
  const claimNumberCheck =
    claimnumber && claimnumber?.startsWith("UnAssigned Claim")
      ? ""
      : claimnumber;

  const getloggedInUserRole = async () => {
    try {
      const userCredentialData = await fetcheaderinfo(loggedInUserid);
      if (userCredentialData) {
        setUserRole(userCredentialData?.currentAppRoleDesc);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCaseStagesNew = async () => {
    try {
      const response = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Case_Stages,
        triggerById: loggedInUserid,
      });
      setResponseCaseid(response);
      const foundStage = response.find(
        (item: { label: string }) => item.label === CASE_STAGE_STATUS.NEW,
      );
      setNewStage(foundStage?.label || null);
    } catch (error) {
      console.error("Error fetching case stages:", error);
    }
  };

  useEffect(() => {
    getloggedInUserRole();
  }, [loggedInUserid]);

  useEffect(() => {
    setActiveTab("Patient");
    setInjuryActiveTab("Patient Information");
    dispatch(
      setCurrentStage(
        userData?.caseStageName
          ? userData?.caseStageName
          : CASE_STAGE_STATUS.NEW,
      ),
    );
    dispatch(setIsSearchEditable(true));
  }, []);

  useEffect(() => {
    if (userData?.caseInfoId) {
      setNewStage(userData?.caseStageDesc);
      dispatch(setCaseInfoId(userData?.caseInfoId));
      dispatch(setCaseId(userData?.caseId));
      dispatch(setCaseStage(userData?.caseStageName));
      dispatch(setClaimNumber(userData?.masterClaimNumber));
       dispatch(setCaseTypeName(userData?.caseReviewTypeName));
      dispatch(setCurrentStage(userData?.caseStageName));
      dispatch(setInjuryAvailable(userData?.isInjuryAvailable));
      dispatch(setRecordAvailable(userData?.isRecordAvailable));
      dispatch(setQMEScheduleAvailable(userData?.isQMEScheduleAvailable));
      dispatch(setBillingAvailable(userData?.isBillingAvailable));
      dispatch(setIsViewSchedule(false));
      if (userData?.subjectFullName) {
        dispatch(setPatientDetails(userData?.subjectFullName));
      }
    } else {
      fetchCaseStagesNew();
    }
  }, [userData, dispatch]);

  useEffect(() => {
    const getCaseSubject = async () => {
      try {
        if (userData?.caseInfoId) {
          const subjectInfo = await fetchSubjectInfo(userData.caseInfoId);

          if (subjectInfo?.caseSubjectId) {
            setCaseSubjectIdNew(subjectInfo?.caseSubjectId);
            dispatch(setCaseSubjectId(subjectInfo?.caseSubjectId));
            if (!userData?.caseId) {
              dispatch(setCaseId(subjectInfo?.caseId));
              dispatch(setCaseStage(subjectInfo?.caseStageName));
              dispatch(setClaimNumber(subjectInfo?.claimNumber));
              dispatch(setCurrentStage(subjectInfo?.caseStageName));
              dispatch(setInjuryAvailable(subjectInfo?.isInjuryAvailable));
              dispatch(setRecordAvailable(subjectInfo?.isRecordAvailable));
              dispatch(
                setQMEScheduleAvailable(subjectInfo?.isQMEScheduleAvailable),
              );
              dispatch(setBillingAvailable(subjectInfo?.isBillingAvailable));
            }
          }
          if (subjectInfo?.genderName) {
            setGender(subjectInfo.genderName);
          }
          if (subjectInfo) {
            const formattedName =
              `${subjectInfo.salutationName || ""} ${subjectInfo.lastName || ""}, ${subjectInfo.firstName || ""} (${subjectInfo.customerAccountNo || ""})`
                .replace(/\s+/g, " ")
                .trim();
            dispatch(setPatientDetails(formattedName));
          }
        }
      } catch (error) {
        console.error("Error fetching subject info:", error);
      }
    };

    getCaseSubject();
  }, [userData?.caseInfoId]);

  useEffect(() => {
    const fetchInjuryDetails = async () => {
      try {
        const injuries = await FetchInjuryDetails(caseSubjectId);
        setCaseSubjectInjuryID(
          injuries?.result?.[0]?.caseSubjectInjuryID ?? null,
        );
      } catch {
        setCaseSubjectInjuryID(null);
      }
    };

    if (caseSubjectId && injuryActiveTab === "Injury") {
      fetchInjuryDetails();
    }
  }, [caseSubjectId, caseInfoId, injuryActiveTab]);

  const handleAppointmentBack = () => {
    if (!isRowActionTriggered) {
      onCancel("Cancel");
    } else {
      handleTabChangeNew("Appointment List");
    }
  };

  const handleBillingBack = () => {
    if (!isRowActionTriggered) {
      onCancel("Cancel");
    } else {
      handleBillingTabChange("Case Billing List");
    }
  };

  const handleRecordBack = () => {
    if (!isRecordRowActionTriggered) {
      onCancel("Cancel");
    } else {
      handleRecordTabChange("Record List");
    }
  };

  const handleInjuryBack = () => {
    if (!isRowActionTriggered) {
      onCancel("Cancel");
    } else {
      handleInjuryTabChangeNew("Injury List");
    }
  };

  const handleRowAction = (row: any) => {
    setSelectedRowData(row);
    setIsRowActionTriggered(true);
    setQmeActiveTab("Schedule Appointment");
  };

  const handleBillingRowAction = (row: any) => {
    setSelectedRowData(row);
    setIsRowActionTriggered(true);
    setbillingActiveTab("Add Configuration");
  };

  const handleRecordRowAction = (row: any) => {
    setSelectedRecordRowData(row);
    setIsRecordRowActionTriggered(true);
    setIsRowActionTriggered(true);
    setRecordActiveTab("Upload Records");
  };

  const handleTabChangeNew = (key: string | null) => {
    if (key === "Appointment List") {
      setQmeActiveTab("Appointment List");
      setIsRowActionTriggered(false);
    } else if (key === "Schedule Appointment") {
      setQmeActiveTab("Schedule Appointment");
      if (!isRowActionTriggered) {
        setSelectedRowData(null);
      }
      setSelectedRowData(null);
      setIsRowActionTriggered(false);
    }
  };

  const handleBillingTabChange = (key: string | null) => {
    if (key === "Case Billing List") {
      setbillingActiveTab("Case Billing List");
      setIsRowActionTriggered(false);
    } else if (key === "Add Configuration") {
      setbillingActiveTab("Add Configuration");
      if (!isRowActionTriggered) {
        setSelectedRowData(null);
      }
      setSelectedRowData(null);
      setIsRowActionTriggered(false);
    }
  };

  const handleInjuryTabChangeNew = (key: string | null) => {
    if (key === "Patient Information") {
      setInjuryActiveTab("Patient Information");
      setSelectedRowData(null);
      setIsRowActionTriggered(false);
    } else if (key === "Injury") {
      setInjuryActiveTab("Injury");
      setSelectedRowData(null);
      setIsRowActionTriggered(false);
    } else if (key === "Injury List") {
      setInjuryActiveTab("Injury List");
      setSelectedRowData(null);
      setIsRowActionTriggered(false);
    } else if (key === "Header") {
      setInjuryActiveTab("Header");
    } else if (key === "Parties") {
      setInjuryActiveTab("Parties");
    }
  };

  const handleRecordTabChange = (key: string | null) => {
    if (key === "Record List") {
      setRecordActiveTab("Record List");
      setIsRecordRowActionTriggered(false);
    } else if (key === "Upload Records") {
      setRecordActiveTab("Upload Records");
      if (!isRecordRowActionTriggered) {
        setSelectedRecordRowData(null);
      }
      setIsRecordRowActionTriggered(false);
    } else if (key === "Preferences") {
      setRecordActiveTab("Preferences");
      if (!isRecordRowActionTriggered) {
        setSelectedRecordRowData(null);
      }
      setIsRecordRowActionTriggered(false);
    }
  };

  const handleTabChange = () => {
    setQmeActiveTab("Appointment List");
  };

  const handleSaveBillingTabChange = () => {
    setbillingActiveTab("Case Billing List");
  };

  const handleinjuryTabChange = () => {
    setInjuryActiveTab("Injury List");
  };

  const handleRecordTab = () => {
    setRecordActiveTab("Record List");
  };

  useEffect(() => {
    if (selectedRowData) {
      setQmeActiveTab("Schedule Appointment");
    }
    if (selectedRecordRowData) {
      setRecordActiveTab("Upload Records");
    }
  }, [selectedRowData, selectedRecordRowData]);

  useEffect(() => {
    setSelectedRowData(null);
    setSelectedRecordRowData(null);
    dispatch(setIsViewSchedule(false));
    if (activeTab === "Records") {
      setRecordActiveTab(isRecordAvailable ? "Record List" : "Upload Records");
    }
    if (activeTab === "Patient") {
      setInjuryActiveTab("Patient Information");
    }
    if (activeTab === "QME Schedule") {
      setQmeActiveTab(
        isQMEScheduleAvailable ? "Appointment List" : "Schedule Appointment",
      );
    }
    if (activeTab === "Billing") {
      if (isBillingAvailable) {
        setbillingActiveTab("Case Billing List");
      } else {
        setbillingActiveTab("Add Configuration");
      }
    }
  }, [activeTab]);

  const handleRowActionInjury = (row: any) => {
    setSelectedRowData(row);
    setIsRowActionTriggered(true);
    setInjuryActiveTab("Injury");
  };

  const toggleDrawer = () => {
    setShowDrawer((prev) => !prev);
  };

  const handleStatusLog = () => {
    setIsStageLogOpen(true);
  };

  const handleCloseStageLog = () => {
    setIsStageLogOpen(false);
  };

  const handleCloseNotes = () => {
    if (isUploadFile) {
      setShowUploadWarning(true);
    } else {
      setShowDrawer(false);
      dispatch(setIsUploadFile(false));
    }
  };

  const handleUploadInteraction = () => {
    setShowUploadWarning(false);
    setShowDrawer(false);
    dispatch(setIsUploadFile(false));
  };

  const handleCloseModalWarning = () => {
    setShowUploadWarning(false);
  };

  const allowedRoles = [
    WEB_ROLE.Billing_Specialist,
    WEB_ROLE.Editor,
    WEB_ROLE.Medical_Assistant,
    WEB_ROLE.Record_Reviewer,
    WEB_ROLE.QME_Doctor,
    WEB_ROLE.App_Admin,
    WEB_ROLE.IndependentQMEDoctor,
    WEB_ROLE.Scheduler,
    WEB_ROLE.Historian,
    WEB_ROLE.Claims_Administrator,
    WEB_ROLE.Supervisor,
  ];

  const allowedRolesForInvoiceLineItems = [
    WEB_ROLE.App_Admin,
    WEB_ROLE.Billing_Specialist,
  ];

  const hiddenTabs = ["Invoice", "Billing"];
  const canShowAddNotes = allowedRoles.includes(userRole);
  const disableInvoiceLineItems =
    allowedRolesForInvoiceLineItems.includes(userRole);
  const visibleTabs = disableInvoiceLineItems
    ? TABS
    : TABS.filter((tab) => !hiddenTabs.includes(tab));

  const isTabDisabled = (tab: string) => {
    if (!caseInfoId && tab !== "Patient") return true;

    if (tab === "QME Schedule") {
      return (
        currentStage === CASE_STAGE_STATUS.NEW ||
        (currentStage === CASE_STAGE_STATUS.REGISTERED && !isInjuryAvailable)
      );
    }

    if (tab === "Records") {
      return (
        currentStage === CASE_STAGE_STATUS.NEW ||
        (currentStage === CASE_STAGE_STATUS.REGISTERED &&
          !isQMEScheduleAvailable)
      );
    }

    if (tab === "Invoice") {
      return (
        currentStage === CASE_STAGE_STATUS.NEW ||
        (currentStage === CASE_STAGE_STATUS.REGISTERED &&
          !isQMEScheduleAvailable)
      );
    }

    return false;
  };

  const [rushNotesData, setRushNotesData] = useState<any[]>([]);

  const fetchRushNotes = async () => {
    try {


      const payload = {
        searchString: "",
        startDate: null,
        endDate: null,
        caseInfoId: caseInfoId,
      };

      const data = await getAllRushNotes(payload);
      setRushNotesData(data)

    } catch (error) {
      console.error("Error fetching rush notes:", error);
    } finally {

    }
  };

  useEffect(() => {
    if (caseInfoId) {
      fetchRushNotes();
    }
  }, [caseInfoId]);


  return (
    <>
      <div>
        <div className="breadcrumbg pb-0">
          <Container fluid className="px-5">
            <Stack direction="horizontal" gap={2}>
              <Col className="pt-0 flex-column d-flex align-items-start fade-in-left">
                <h4>CASE DETAILS</h4>
                <Tabs
                  activeKey={activeTab}
                  onSelect={(tab) => tab && setActiveTab(tab)}
                  className="mb-0 Tab_borderBottom fade-in-right"
                >
                  {visibleTabs.map((tab) => (
                    <Tab
                      eventKey={tab}
                      title={tab}
                      key={tab}
                      disabled={isTabDisabled(tab)}
                    />
                  ))}
                </Tabs>
              </Col>

              {rushNotesData?.length > 0 && (
                <div className="d-flex align-items-center">
                  <span
                    className="rushIcon rushiconDashboard"
                    style={{ top: "-5px", width: "35px", height: "35px" }}
                  >
                    <span
                      className="material-symbols-outlined me-2 rushicon p-1 heartbeat"
                      style={{
                        cursor: "pointer",
                        fontSize: "20px",
                        marginTop: "2px",
                        marginLeft: "2px",
                      }}
                      onClick={() => setShowRushNotes(true)}
                    >
                      sprint
                    </span>
                  </span>
                </div>
              )}

              {caseid ? (
                <div className={caseid ? "border-end added_top" : ""}>
                  {patientDetails && (
                    <h6
                      className="fade-in-right mt-1 d-flex"
                      style={{ lineHeight: "15px" }}
                    >
                      <span className="caseinfo">Patient</span> :{" "}
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          patientDetails.length > 20 ? (
                            <Tooltip id="tooltip-patient">
                              {patientDetails}
                            </Tooltip>
                          ) : (
                            <></>
                          )
                        }
                      >
                        <span className="casedetail text-truncate">
                          {patientDetails}
                        </span>
                      </OverlayTrigger>
                    </h6>
                  )}
                  <h6
                    className="fade-in-right mt-1 d-flex"
                    style={{ lineHeight: "15px" }}
                  >
                    <span className="caseinfo">Case ID</span> :{" "}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        caseid.length > 20 ? (
                          <Tooltip id="tooltip-caseid">{caseid}</Tooltip>
                        ) : (
                          <></>
                        )
                      }
                    >
                      <span className="casedetail text-truncate">{caseid}</span>
                    </OverlayTrigger>
                  </h6>

                  {claimNumberCheck !== "" && (
                    <h6 className="fade-in-right d-block d-flex">
                      <span className="caseinfo">Claim Number</span> :{" "}
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          claimnumber?.length > 20 ? (
                            <Tooltip id="tooltip-claim">{claimnumber}</Tooltip>
                          ) : (
                            <></>
                          )
                        }
                      >
                        <span className="casedetail text-truncate">
                          {caseid && claimnumber ? claimnumber : ""}
                        </span>
                      </OverlayTrigger>
                    </h6>
                  )}
                </div>
              ) : (
                ""
              )}
              <h6 className=" fade-in-right" style={{ marginBottom: "0px" }}>
                Stage : <span className="case-status">{currentStage}</span>
              </h6>
              {caseInfoId && (
                <span
                  className="material-symbols-outlined theme-color"
                  style={{ cursor: "pointer" }}
                  onClick={handleStatusLog}
                >
                  schedule
                </span>
              )}
              {caseInfoId &&
                ![
                  CASE_STAGE_STATUS.CLOSED,
                  CASE_STAGE_STATUS.CANCELLED,
                ].includes(currentStage) &&
                (!view_Case || canShowAddNotes) && (
                  <div
                    className="notification-icon position-relative"
                    onClick={toggleDrawer}
                  >
                    <span
                      className="material-symbols-outlined calendar-arrow p-1"
                      style={{ cursor: "pointer" }}
                    >
                      add_notes
                    </span>
                  </div>
                )}
            </Stack>
          </Container>
        </div>

        <div className="main_wrapper_section pills_wrapper ">
          <div className="px-5">
            {activeTab === "Patient" && (
              <Tabs
                defaultActiveKey="Patient"
                activeKey={injuryActiveTab}
                onSelect={handleInjuryTabChangeNew}
                className="mt-3 mb-3 fade-in-left"
              >
                <Tab eventKey="Patient Information" title="Patient Information">
                  {injuryActiveTab === "Patient Information" && (
                    <Case_Subject
                      userData={userData}
                      action={action}
                      loggedInUserid={loggedInUserid}
                      caseStageId={responseCaseid}
                      onCancel={onCancel}
                      headerActiveTab={injuryActiveTab}
                      userRole={userRole}
                    />
                  )}
                </Tab>
                <Tab eventKey="Header" title="Header" disabled={!caseInfoId}>
                  {injuryActiveTab === "Header" && (
                    <Header
                      userData={userData}
                      action={action}
                      loggedInUserid={loggedInUserid}
                      caseStageId={responseCaseid}
                      activeTab={activeTab}
                      onCancel={onCancel}
                      headerActiveTab={injuryActiveTab}
                      userRole={userRole}
                    />
                  )}
                </Tab>
                <Tab
                  eventKey="Parties"
                  title="Parties"
                  disabled={
                    !caseInfoId || (claimNumberCheck === "" && caseInfoId)
                  }
                >
                  {injuryActiveTab === "Parties" && (
                    <Stakeholders
                      userData={userData}
                      action={action}
                      loggedInUserid={loggedInUserid}
                      caseStageId={responseCaseid}
                      onCancel={onCancel}
                      headerActiveTab={injuryActiveTab}
                    />
                  )}
                </Tab>

                <Tab
                  eventKey="Injury"
                  title="Injury"
                  disabled={
                    !caseSubjectId ||
                    (claimNumberCheck === "" && caseSubjectId) ||
                    currentStage === CASE_STAGE_STATUS.NEW
                  }
                >
                  {injuryActiveTab === "Injury" && (
                    <InjuryForm
                      userData={userData}
                      action={action}
                      loggedInUserid={loggedInUserid}
                      caseStageId={responseCaseid}
                      caseSubjectID={caseSubjectId || caseSubjectIdNew}
                      onTabChange={handleinjuryTabChange}
                      onCancel={handleInjuryBack}
                      genderNew={gender}
                      caseInfoID={caseInfoId}
                      activeKey={injuryActiveTab}
                      caseSubjectInjuryID={caseSubjectInjuryID}
                      claimnumber={claimnumber}
                      selectedRowData={selectedRowData}
                    />
                  )}
                </Tab>
                <Tab
                  eventKey="Injury List"
                  title="Injury List"
                  disabled={!isInjuryAvailable}
                >
                  {injuryActiveTab === "Injury List" && (
                    <InjuryDetailsTable
                      caseInfoID={caseInfoId}
                      caseSubjectID={caseSubjectId || caseSubjectIdNew}
                      onRowSelect={handleRowActionInjury}
                      subTab={subTab}
                      activeKey={injuryActiveTab}
                    />
                  )}
                </Tab>
              </Tabs>
            )}
            {activeTab === "QME Schedule" && (
              <Tabs
                activeKey={qmeActiveTab}
                onSelect={handleTabChangeNew}
                className={isViewSchedule ? "mb-3 mt-3 conditionalHide" : "mb-3 mt-3"}
              >
                <Tab
                  eventKey="Schedule Appointment"
                  title="Schedule Appointment"
                  disabled={selectedRowData != null && isRowActionTriggered}
                >
                  {qmeActiveTab === "Schedule Appointment" && (
                    <ScheduleAppointment
                      userData={userData}
                      action={action}
                      loggedInUserid={loggedInUserid}
                      caseStageId={responseCaseid}
                      onCancel={handleAppointmentBack}
                      selectedRowData={selectedRowData}
                      onTabChange={handleTabChange}
                      qmeActiveTab={qmeActiveTab}
                      isRowActionTriggered={isRowActionTriggered}
                      activeTab={activeTab}
                      setSelectedRowData={setSelectedRowData}
                    />
                  )}
                </Tab>
                <Tab
                  eventKey="Appointment List"
                  title="Appointment List"
                  disabled={!isQMEScheduleAvailable}
                >
                  {qmeActiveTab === "Appointment List" && (
                    <AppointmentList
                      userData={userData}
                      action={action}
                      loggedInUserid={loggedInUserid}
                      caseStageId={responseCaseid}
                      onCancel={onCancel}
                      onRowSelect={handleRowAction}
                      qmeActiveTab={qmeActiveTab}
                    />
                  )}
                </Tab>
              </Tabs>
            )}
            {activeTab === "Records" && (
              <Tabs
                activeKey={recordActiveTab}
                onSelect={handleRecordTabChange}
                className="mb-3 mt-3"
              >
                <Tab
                  eventKey="Upload Records"
                  title="Upload Records"
                  disabled={
                    selectedRecordRowData != null && isRecordRowActionTriggered
                  }
                >
                  {recordActiveTab === "Upload Records" && (
                    <UploadRecords
                      caseInfoId={caseInfoId}
                      userData={userData}
                      loggedInUserid={loggedInUserid}
                      onCancel={handleRecordBack}
                      selectedRowData={selectedRecordRowData}
                      onTabChange={handleRecordTab}
                      recordActiveTab={recordActiveTab}
                      isRowActionTriggered={isRecordRowActionTriggered}
                      activeTab={activeTab}
                    />
                  )}
                </Tab>
                <Tab
                  eventKey="Record List"
                  title="Record List"
                  disabled={!isRecordAvailable}
                >
                  {recordActiveTab === "Record List" && (
                    <RecordListNew
                      caseInfoId={caseInfoId}
                      action={action}
                      loggedInUserid={loggedInUserid}
                      onCancel={onCancel}
                      onRowSelect={handleRecordRowAction}
                      recordActiveTab={recordActiveTab}
                    />
                  )}
                </Tab>
                <Tab eventKey="Preferences" title="Preferences">
                  {recordActiveTab === "Preferences" && (
                    <Preferences userRole={userRole} />
                  )}
                </Tab>
              </Tabs>
            )}
            {activeTab === "Activities" && (
              <div className="mt-3">
                <CaseActivityList
                  userData={userData}
                  action={action}
                  loggedInUserid={loggedInUserid}
                  caseStageId={responseCaseid}
                  onCancel={onCancel}
                  shouldRefreshActivity={shouldRefreshActivity}
                  setShouldRefreshActivity={setShouldRefreshActivity}
                />
              </div>
            )}
            {activeTab === "Summary" && (
              <div className="mt-3">
                <SummaryReport />
              </div>
            )}
            {activeTab === "Billing" && (
              <Tabs
                activeKey={billingActiveTab}
                onSelect={handleBillingTabChange}
                className="mb-3 mt-3"
              >
                <Tab
                  eventKey="Add Configuration"
                  title="Add Configuration"
                  disabled={selectedRowData != null && isRowActionTriggered}
                >
                  {billingActiveTab === "Add Configuration" && (
                    <CaseBillingAddConfiguration
                      caseUserData={userData}
                      onCancel={handleBillingBack}
                      onTabChange={handleSaveBillingTabChange}
                      selectedData={selectedRowData}
                      isRowActionTriggered={isRowActionTriggered}
                      billingActiveTab={billingActiveTab}
                    />
                  )}
                </Tab>
                <Tab
                  eventKey="Case Billing List"
                  title="Case Billing List"
                  disabled={!isBillingAvailable}
                >
                  {billingActiveTab === "Case Billing List" && (
                    <CaseBillingList
                      onCancel={onCancel}
                      billingActiveTab={billingActiveTab}
                      onRowSelect={handleBillingRowAction}
                    />
                  )}
                </Tab>
              </Tabs>
            )}
            {activeTab === "Invoice" && (
              <div className="mt-3">
                <ViewInvoice
                  selectedRow={userData ?? { caseInfoId: caseInfoId }}
                  onClose={onCancel}
                  isCase={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <NotesDrawer
        title={"Add Notes"}
        open={showDrawer}
        onClose={handleCloseNotes}
        placement="end"
        isUploadFile={isUploadFile}
      >
        <AddCaseNotes
          showDrawer={showDrawer}
          onClose={() => setShowDrawer(false)}
          caseId={caseid}
          isRowActionTriggered={isRecordRowActionTriggered}
          onNotesSaved={() => {
            setShouldRefreshActivity(true);
            fetchRushNotes();
          }}
        />
      </NotesDrawer>
      {isStageLogOpen && (
        <StageStatusLogs
          show={isStageLogOpen}
          handleClose={handleCloseStageLog}
          caseInfoId={caseInfoId}
        />
      )}
      <Modal
        data-ignore-click-outside
        show={showUploadWarning}
        onHide={handleCloseModalWarning}
      >
        <Modal.Body className="fw-bold text-left modelheading">
          <div>
            Your files are currently uploading. Cancelling now will discard any
            in-progress uploads. Are you sure?
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalWarning}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            id="cancel-upload-button"
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={handleUploadInteraction}
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <AppointmentActionDrawer
        open={showRushNotes}
        onClose={() => setShowRushNotes(false)}
        title={
          <div className="d-flex align-items-center">
            <span className="rushIcon1">
              <span className="material-symbols-outlined me-2 rushicon p-1">
                sprint
              </span>
            </span>
            <span className="rushTitle"> Rush Notes</span>
          </div>
        }
      >
        <AllRushNotesDetails caseid={caseInfoId} hideFilters={true} />
      </AppointmentActionDrawer>
    </>
  );
};

export default CreateNewCase;
